<div class="container fblock mat-elevation-z8">
    <div class="row orangebar justify-content-center mb-3">
        <div class="col-12 text-center">
            <h1 class=" coolfont">Our Customers' Feedbacks</h1>
        </div>
    </div>
    <div class="row justify-content-between text-center mb-3">
        <div class="col-lg-3 col-xs-12 curved mat-elevation-z8 mr-3 mb-3 ml-3 orangebar">
            <div class="row mat-elevation-z8 bluebar coolfont">
                <div class="col-12"><h4>Akshay Dixit</h4>
                    <p> Civil Lines - Jabalpur </p>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col-12 coolfont"><p>"PureNet is an excellent internet service. They install & activate internet on same day of connection. Their connection takes 2-3 hours of time, thats it! Highly recommended!!"</p></div>
            </div>
        </div>
        <div class="col-lg-3 col-xs-12 curved mat-elevation-z8 ml-3 mb-3 mr-3 bluebar">
            <div class="row mat-elevation-z8 orangebar coolfont">
                <div class="col-12"><h4>Roopesh Jadav</h4>
                    <p>Ranjhi - Jabalpur</p>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col-12 coolfont"><p>"PureNet came to be wow service for me. I was requesting telecom companies to provide connection in Ranjhi from months but no response. PureNet people did the job in one day only...5 star service people."</p></div>
            </div>
        </div>
        <div class="col-lg-3 col-xs-12 curved mat-elevation-z8 ml-3 mb-3 mr-3 orangebar">
            <div class="row mat-elevation-z8 bluebar coolfont">
                <div class="col-12"><h4>Ashwin Malviya</h4>
                    <p> Katanga - Jabablpur </p>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col-12 coolfont"><p>"I was highly fed up with my internet connection due to high downtime of dsl broadband in Katanga area. PureNet installed wireless connection and now their is no more cable problem...thanks PureNet."</p></div>
            </div>
        </div>
    </div>
</div>